import React from 'react';
import { Link } from 'react-router-dom';
import { Edit, Trash2, MapPin, Bed, Bath } from 'lucide-react';

const PropertyGrid = ({ properties, onDelete }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {properties.map((property) => (
        <div
          key={property.id}
          className="bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-200 dark:border-gray-700"
        >
          {/* Property Image Section */}
          <div className="relative h-48">
            {property.images && property.images[0] ? (
              <img
                src={property.images[0]?.url}
                alt={property.title}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 text-lg font-medium">
                <span>No Image Available</span>
              </div>
            )}
            {/* Property Status Badge */}
            <div className="absolute top-3 right-3">
              <span
                className={`text-xs font-semibold px-2 py-1 rounded-full capitalize ${
                  property.status === 'available'
                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
                    : property.status === 'pending'
                    ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300'
                    : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
                }`}
              >
                {property.status}
              </span>
            </div>
            
            {/* Featured Badge  */}
            {property.featured && (
              <span className="absolute top-3 left-3 bg-yellow-400 text-black text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                FEATURED
              </span>
            )}

          </div>

          {/* Property Details Section */}
          <div className="p-4 sm:p-5">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
              <Link to={`/properties/${property.id}`} className="hover:text-primary-600 transition-colors duration-200">{property.title}</Link>
            </h3>
            <p className="flex items-center text-gray-600 dark:text-gray-400 mb-2">
              <MapPin className="h-4 w-4 mr-1 text-primary-500" />
              {property.location}, {property.city}
            </p>
            <div className="flex items-center space-x-4 text-gray-700 dark:text-gray-300 mb-4">
              <span className="flex items-center gap-1">
                <Bed className="h-4 w-4 text-primary-500" />
                {property.bedrooms} Beds
              </span>
              <span className="flex items-center gap-1">
                <Bath className="h-4 w-4 text-primary-500" />
                {property.bathrooms} Baths
              </span>
            </div>
            <div className="flex items-center justify-between text-lg font-bold text-gray-900 dark:text-white pt-2 border-t border-gray-100 dark:border-gray-700">
              <span>₹ {property.price.toLocaleString()}</span>
              <span className="text-sm font-semibold text-gray-600 dark:text-gray-400">
                {property.area} sqft
              </span>
            </div>
          </div>

          <div className="p-4 bg-gray-50 dark:bg-gray-700 flex justify-between items-center text-sm font-medium border-t border-gray-200 dark:border-gray-600">
              <div className="flex-1 text-gray-800 dark:text-gray-300">
                <span className="bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full">
                  {property.property_type}
                </span>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end space-x-3 pt-4 border-t border-gray-100 dark:border-gray-700">
                <Link
                  to={`/aadashmin/properties/${property.id}/edit`}
                  className="flex items-center gap-1 px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md
                           hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                           transition-colors duration-200 text-sm"
                  title="Edit Property"
                >
                  <Edit className="h-4 w-4" />
                  Edit
                </Link>
                <button
                  onClick={() => onDelete(property.id)}
                  className="flex items-center gap-1 px-4 py-2 bg-red-500 text-white font-semibold rounded-lg shadow-md
                           hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2
                           transition-colors duration-200 text-sm"
                  title="Delete Property"
                >
                  <Trash2 className="h-4 w-4" />
                  Delete
                </button>
              </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PropertyGrid;